<template>
  <v-row>
    <v-col class="py-4">
      <v-row v-if="screen.logo_base64 && !screen.logo_only">
        <v-col
          class="py-0  d-flex justify-center"
          cols="12"
        >
          <v-img
            :height="`${screen.logo_height}px`"
            :width="`${screen.logo_width}px`"
            :src="'data:image/jpg;base64,'+screen.logo_base64"
            :max-width="`${screen.logo_width}px`"
            class="force-stretch"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center pb-1">
          <span :style="`color: ${screen.text1.color};font-size: ${screen.text1.size}px`">
            {{ this.screen.text1.text }}
          </span>
        </v-col>
        <!--        <v-col class="text-center pb-1">-->
        <!--          {{ screen.text1.text }}-->
        <!--        </v-col>-->
      </v-row>
      <v-row>
        <v-col class="text-center py-1">
          <span :style="`color: ${screen.text2.color}; font-size: ${screen.text2.size}px`">
            {{ this.screen.text2.text }}
          </span>
        </v-col>
      </v-row>
      <v-row
        v-for="(row, rowIndex) in chunkedItems"
        :key="'row-' + rowIndex"
        justify="center"
      >
        <v-col
          v-for="(planogramm, index) in row"
          v-show="(planogramm.amount>0 && configurationType==ConfigurationTypeEnum.Vitrina) || (planogramm.price_cashless>0 && configurationType==ConfigurationTypeEnum.Donation) || (planogramm.amount>0 && configurationType==ConfigurationTypeEnum.Rele)"
          :key="index + 'f'"
          :cols="getColumnWidth(row.length)"
        >
          <v-btn
            width="100%"
            :style="`color: ${screen.buttonsExt[index + rowIndex*2].text.color}; background-color: ${screen.buttonsExt[index + rowIndex*2].background}; border-radius: ${screen.buttonsExt[index + rowIndex*2].radius}px; font-size: ${screen.buttonsExt[index + rowIndex*2].text.size}px; white-space: normal; display: flex; flex-direction: column;`"
            @click="onChooseItem(planogramm)"
          >
            {{ showOnTheButton(planogramm) }}
          </v-btn>
        </v-col>

        <v-col
          v-for="(planogramm, index2) in row"
          v-show="((planogramm.amount==0 || !planogramm.amount) && (configurationType==ConfigurationTypeEnum.Vitrina || configurationType==ConfigurationTypeEnum.Rele)) || (planogramm.price_cashless==0 && (configurationType==ConfigurationTypeEnum.Donation ))"
          :key="index2 + 'z'"
          cols="12"
        >
          <v-btn
            width="100%"
            :style="`color: ${screen.buttonsExt[index2 + rowIndex*2].text.color}; background-color: ${screen.buttonsExt[index2 + rowIndex*2].background}; border-radius: ${screen.buttonsExt[index2 + rowIndex*2].radius}px; font-size: ${screen.buttonsExt[index2 + rowIndex*2].text.size}px; white-space: normal; display: flex; flex-direction: column;`"
            @click="onChooseScreen(planogramm)"
          >
            {{ showOnTheButton(planogramm) }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script >
import {
  configuration,
  ConfigurationDescriptionTypeEnum,
  ConfigurationTypeEnum
} from "@/views/loyalty/models/justpay-configuration.model"
import { setScreenBackground } from "@/views/loyalty/shared/modules/utilities"

export default {
  name: 'ConfigurationFirstscreen',
  props: {
    configurationType: {
      type: Number,
      default: 0
    },
    screen: {
      type: Object,
      default: configuration.interface_description.first_screen
    },
    planogramms: {
      type: Array,
      default: configuration.planogramm
    },
    nomenclatures: {
      type: Array,
    }
  },
  data: () => ({
    // myStyle: { backgroundColor: '' },
    planogramm: null,
}),
  computed: {
    ConfigurationTypeEnum () {
      return ConfigurationTypeEnum
    },
    logoReady () {
      return {
        show: this.screen.logo_only,
        data: this.screen.logo_base64
      }
    },
    // Разбиваем массив на подмассивы по 3 элемента
    chunkedItems () {
      const chunks = []
      // const planogrammsWithoutZeroCache = this.planogramms.filter(f=>(f.amount!==0 && f.price_cashless!==0))
      // for (let i = 0; i < planogrammsWithoutZeroCache.length; i += 3) {
      //   chunks.push(planogrammsWithoutZeroCache.slice(i, i + 3));
      // }
      for (let i = 0; i < this.planogramms.length; i += 2) {
        chunks.push(this.planogramms.slice(i, i + 2))
      }
      return chunks
    }
  },
  watch: {
    'screen.background' (newValue) {
      setScreenBackground(newValue)
    },
    logoReady (val) {
      if (val.show && val.data) {
        setScreenBackground('data:image/jpg;base64,' + val.data)
      }
    },
  },
  beforeMount () {
    console.log('text->', this.screen.text1.text)
  },
  methods: {
    getColumnWidth (count) {
      // if (count === 1) return 12;
      // if (count === 2) return 6;
      return 6
    },
    async onChooseItem (planogramm) {
      this.planogramm = planogramm
      console.log('planogram', planogramm)
      if (this.configurationType == ConfigurationTypeEnum.Donation) {
        if (planogramm.price_cashless == 0) {
          // this.firstScreen = false
          // this.secondScreen = true
          // this.errorScreen = false
          this.priceOfGoods = planogramm.price_cashless
        } else {
          this.amountForPay = planogramm.price_cashless
          console.log('this.amountForPay', this.amountForPay)
          const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
          console.log('nomenclature', nomenclature)
          const items = [{
            name: nomenclature.name,
            count: 1,
            amount: this.amountForPay,
            price: this.amountForPay
          }]
          console.log('items', items)
          this.startToPay(items)
        }
      }
      if (this.configurationType == ConfigurationTypeEnum.Vitrina) {
        if (planogramm.amount == 0 || !planogramm.amount) {
          // this.firstScreen = false
          // this.secondScreen = true
          // this.errorScreen = false
          this.priceOfGoods = planogramm.price_cashless
        } else {
          this.amountForPay = planogramm.amount * planogramm.price_cashless
          console.log('this.amountForPay', this.amountForPay)
          const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
          console.log('nomenclature', nomenclature)
          const items = [{
            name: nomenclature.name,
            count: this.planogramm.amount,
            amount: this.amountForPay,
            price: planogramm.price_cashless
          }]
          this.startToPay(items)
        }
      }
      // 9 is the relay
      if (this.configurationType == ConfigurationTypeEnum.Rele) {
        this.amountForPay = planogramm.amount * planogramm.price_cashless
        console.log('this.amountForPay', this.amountForPay)
        // const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
        // console.log('nomenclature', nomenclature)
        const items = [{
          amount: this.amountForPay,
          count: 1,
          equipmentId: planogramm.equipment,
          name: planogramm.description, //  nomenclature.name,
          price: this.amountForPay,
          scenarioId: planogramm.scenario
        }]
        console.log('items', items)
        this.startToPay(items)
      }
    },
    onChooseScreen (planogramm) {
      this.amountForPay = planogramm.price_cashless
      console.log('this.amountForPay', this.amountForPay)
      const item = {
        amount: this.amountForPay,
        count: 1,
        equipmentId: planogramm.equipment,
        name: planogramm.description, //  nomenclature.name,
        price: this.amountForPay,
        scenarioId: planogramm.scenario
      }
      console.log('item', item)
      this.$emit('screen', item)
    },
    showOnTheButton (planogramm) {
      let itemToShow = 0
      if (this.configurationType == ConfigurationTypeEnum.Donation) {
        if (planogramm.price_cashless > 0) {
          itemToShow = planogramm.price_cashless
        } else {
          itemToShow = 'Выбор...'
        }
      }
      if (this.configurationType == ConfigurationTypeEnum.Vitrina) {
        itemToShow = planogramm.amount
      }
      if (this.configurationType == ConfigurationTypeEnum.Rele) {
        if (planogramm.descriptionType == ConfigurationDescriptionTypeEnum.Sum) {
          itemToShow = `${planogramm.amount * planogramm.price_cashless} ${this.unitOfMeasure(planogramm.descriptionType)}`
        }
        if (planogramm.descriptionType == ConfigurationDescriptionTypeEnum.Quantity) {
          itemToShow = `${planogramm.amount} ${this.unitOfMeasure(planogramm.descriptionType)}`
        }
        if (planogramm.descriptionType == ConfigurationDescriptionTypeEnum.Overview
        ) {
          itemToShow = planogramm.description
        }
      }
      return itemToShow
    },
    startToPay (items) {
      this.$emit('data', items)
    },
    unitOfMeasure (type) {
      if (type === ConfigurationDescriptionTypeEnum.Sum) return 'руб.'
      if (type === ConfigurationDescriptionTypeEnum.Quantity) return 'шт.'
    }
  }
}
</script>

<style scoped>
/* Обращаемся к внутреннему контейнеру Vuetify, который держит фон */
.force-stretch ::v-deep .v-image__image {
  background-size: 100% 100% !important; /* Растянуть на всю ширину и высоту без обрезки */
}

/* На случай если используется тег img (зависит от конфигурации v-img) */
.force-stretch ::v-deep img {
  object-fit: fill !important; /* Игнорировать пропорции, заполнить всё пространство */
}
</style>
